import { render } from "./View30.vue?vue&type=template&id=676fabee"
import script from "./View30.vue?vue&type=script&lang=js"
export * from "./View30.vue?vue&type=script&lang=js"

import "./View30.vue?vue&type=style&index=0&id=676fabee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__